import { type LabelHTMLAttributes, forwardRef } from 'react';
import { cn } from '@/lib/utils';

export type LabelProps = LabelHTMLAttributes<HTMLLabelElement>;

/**
 * Form label component styled to match the design system.
 *
 * @example
 * ```tsx
 * <Label htmlFor="email">Email</Label>
 * ```
 */
const Label = forwardRef<HTMLLabelElement, LabelProps>(({ className, ...props }, ref) => (
  <label ref={ref} className={cn('text-sm font-medium text-primary', className)} {...props} />
));
Label.displayName = 'Label';

export { Label };
